import axios from './getAxios';
import { contactUsPayloadProps } from './types';

export default async (payload: contactUsPayloadProps) => {
  const transformedPayload = {
    FirstName: payload.firstName,
    LastName: payload.lastName,
    Email: payload.email,
    PhoneNumber: payload.phoneNumber,
    Message: payload.message,
    AdditionalInformation: payload.additionalInformation,
  };

  try {
    const { data } = await axios({
      method: 'POST',
      url: '/api/notifications/contactus',
      data: transformedPayload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
